import { render, staticRenderFns } from "./select-program-categories.vue?vue&type=template&id=616f2612&"
import script from "./select-program-categories.vue?vue&type=script&lang=js&"
export * from "./select-program-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports